import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/tokens.css';
import { initTelemetry } from './telemetry/otel';
import { initLogSink, slog } from './telemetry/logSink';

initLogSink();
initTelemetry();
slog.info('main.mount');

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
